import { BILLING_API_URL } from 'constants/ApiConstants';
import type { MetaAction } from 'modules/global/generic.types';
import * as types from 'modules/metrics/actionTypes';
import type {
  BillingEntityEnum,
  BillingScopeEnum,
  DOCUMENTS_EXPORT_ENTITY,
  DocumentValidationTypeEnum,
} from 'modules/metrics/constants';
import type {
  BillingFilter,
  ClearBillingDashboardFiltersAction,
  ExportBillingAction,
  BillingStatisticExportRequest,
  FetchBillingMetricsAction,
  BillingMetricsQuery,
  RemoveBillingDashboardFilterAction,
  SetBillingDashboardFilterAction,
  SetBillingDashboardFiltersAction,
  SetDocumentsTabAction,
} from 'modules/metrics/types/actions';

/** `url` picks the aggregation level; everything else travels as query params. */
type FetchBillingMetricsPayload = {
  entity: BillingEntityEnum;
  url: BillingScopeEnum;
} & BillingMetricsQuery;

export const fetchBillingMetrics = (
  { entity, url, ...params }: FetchBillingMetricsPayload,
  meta: MetaAction = {}
): FetchBillingMetricsAction => ({
  type: types.FETCH_BILLING_ENTITY_METRICS_REQUEST,
  payload: {
    request: {
      method: 'GET',
      url: `${BILLING_API_URL}/${entity}/${url}`,
      params,
    },
  },
  meta,
});

export const exportBilling = (
  entity: BillingEntityEnum | typeof DOCUMENTS_EXPORT_ENTITY,
  data: BillingStatisticExportRequest,
  meta: MetaAction = {}
): ExportBillingAction => ({
  type: types.EXPORT_BILLING_REQUEST,
  payload: {
    request: {
      method: 'POST',
      url: `${BILLING_API_URL}/${entity}/export`,
      data,
    },
  },
  meta,
});

export const setDocumentsTab = (
  tab: DocumentValidationTypeEnum,
  meta: MetaAction = {}
): SetDocumentsTabAction => ({
  type: types.SET_DOCUMENTS_TAB,
  payload: tab,
  meta,
});

export const setBillingDashboardFilter = (
  field: BillingFilter['field'],
  value: BillingFilter['value'],
  meta: MetaAction = {}
): SetBillingDashboardFilterAction => ({
  type: types.SET_BILLING_DASHBOARD_FILTER,
  payload: { field, value },
  meta,
});

export const setBillingDashboardFilters = (
  filters: BillingFilter[],
  meta: MetaAction = {}
): SetBillingDashboardFiltersAction => ({
  type: types.SET_BILLING_DASHBOARD_FILTERS,
  payload: filters,
  meta,
});

export const removeBillingDashboardFilter = (
  field: BillingFilter['field'],
  value: BillingFilter['value'],
  meta: MetaAction = {}
): RemoveBillingDashboardFilterAction => ({
  type: types.REMOVE_BILLING_DASHBOARD_FILTER,
  payload: { field, value },
  meta,
});

export const clearBillingDashboardFilters = (
  payload: undefined,
  meta: MetaAction = {}
): ClearBillingDashboardFiltersAction => ({
  type: types.CLEAR_BILLING_DASHBOARD_FILTER,
  payload,
  meta,
});
